import { useEffect, useState } from "react";
import { AppConstants } from "../model/enums";

const useSession = () => {
  const [docId, setDocId] = useState<string | null>(null);
  // console.log("1--useSession-started");

  useEffect(() => {
    const fetchSession = async () => {
      try {
        // console.log("2--fetchSession called"); // Bu log görünüyor mu?

        const response = await fetch(`${AppConstants.url}/start-session`, {
          method: "POST",
          // method: "GET",
          credentials: "include", // session cookie'lerini içerebilir
        });

        // console.log("3--response received", response); // Yanıt alındı mı?

        if (!response.ok) {
          throw new Error("Session başlatılamadı");
        }

        const data = await response.json();
        // console.log("4--data received", data); // Backend'den dönen veri nedir?

        setDocId(data.sessionId); // Backend'den gelen session veya docId
        // console.log("5--docId set", data.docId); // `setDocId` çağrıldı mı?
      } catch (error) {
        console.error("Error starting session:", error);
      }
    };

    fetchSession();
  }, []); // [] ile yalnızca bir kez çalıştırılacağını garanti ediyoruz.

  // console.log("9--useSession return", docId);

  return docId;
};

export default useSession;
